import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import logger from "../../../util/logger";
import React from 'react';
import * as _ from "../../../util/lodash";
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { extractElement } from "../../../util";
import { positions, sizes, colors, font } from "../../../enums";
import { whitelistStyles, removeProps } from "../../core/hoc";
import { compose } from 'react-recompose';
import { PrivateMenu } from "../../core/menu/menu";
import MenuItem from "../../core/menu/menu-item";
import Icon from "../../core/icon";
import Image from "../../core/image";
import { PrivateHeader } from "../../core/header/header"; // <AssetRadioMenu
//   items={[ { text, byline, icon, value } ]}
//   label='label text'
//   activeValue={0}
//   float={positions.R}
//   size={sizes.X1}
//   color={colors.ACCENT}
//   onItemClick={myHandler()}
// />

var AssetRadioMenu = createComponent({
  displayName: 'AssetRadioMenu',
  propTypes: {
    items: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      byline: PropTypes.string,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      tooltip: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    })).isRequired,
    label: PropTypes.oneOfType([PropTypes.element, //Label
    PropTypes.string]),
    activeValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    size: PropTypes.oneOf(sizes.ALL),
    "float": PropTypes.oneOf(positions.LR),
    color: PropTypes.oneOf(colors.CORE),
    assetDisplay: PropTypes.oneOf(['inline', 'block', 'inlineByline']),
    isVertical: PropTypes.bool,
    isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    onItemClick: PropTypes.func,
    onChange: PropTypes.func,
    // value will be required, but the required tag has not been added to support backwards compatibility with legacy declarations of the component
    font: PropTypes.shape({
      weight: PropTypes.oneOf(font.weights.ALL),
      family: PropTypes.oneOf(font.families.ALL),
      emphasis: PropTypes.oneOf(font.emphasis.ALL)
    })
  },
  defaultProps: {
    items: [],
    label: null,
    activeValue: null,
    size: sizes.X6,
    "float": null,
    color: colors.ACCENT,
    assetDisplay: 'block',
    isVertical: false,
    isDisabled: false,
    onItemClick: null,
    onChange: null,
    font: {
      emphasis: font.emphasis.NORMAL,
      family: font.families.SYSTEM,
      weight: font.weights.REGULAR
    }
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var _classnames;

    logger.warn('AssetRadioMenu: "onItemClick" prop has been deprecated and will soon be removed entirely. Please update your code to use the new "onChange" prop.', !!p.onItemClick);
    logger.error('AssetRadioMenu: "onChange" is a required property.', !p.onItemClick && !p.onChange);
    var items = extractHeaders(p);

    var props = _.omit(p, ['items', 'float', 'style', 'assetDisplay', 'font']);

    var isDisabled = typeof props.isDisabled === 'function' ? props.isDisabled() : props.isDisabled;
    props.borders = 'none';
    props.menuType = 'asset-radio-menu';
    props.isFluid = false;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames('asset-radio-menu', (_classnames = {}, _classnames["floated " + p["float"]] = !!p["float"], _classnames.disabled = isDisabled, _classnames.wide = p.assetDisplay !== 'block', _classnames)),
      style: p.style
    }, /*#__PURE__*/React.createElement(PrivateMenu, props, items));
  }
});

function extractHeaders(props) {
  var _context;

  var controlIsDisabled = typeof props.isDisabled === 'function' ? props.isDisabled() : props.isDisabled;
  return _mapInstanceProperty(_context = props.items).call(_context, function (item, key) {
    var itemIsDisabled = typeof item.isDisabled === 'function' ? item.isDisabled() : item.isDisabled;
    var isDisabled = controlIsDisabled || itemIsDisabled;
    var isActive = props.activeValue === item.value;
    var color;

    if (!isDisabled) {
      color = props.isInverted ? colors.BASE : colors.DARK;
    }

    if (isActive) {
      color = colors.ACCENT;
    }

    var icon = !!item.icon ? extractElement(Icon, item.icon, {
      name: item.icon,
      size: props.size,
      isDisabled: isDisabled && !isActive,
      color: color
    }).element : null;
    var image = !!item.image ? extractElement(Image, item.image, {
      src: item.image,
      size: props.size,
      isDisabled: isDisabled && !isActive
    }).element : null;
    var onClick = props.onItemClick;

    if (props.onChange) {
      onClick = isActive ? function () {} : props.onChange;
    }

    return /*#__PURE__*/React.createElement(MenuItem, {
      key: key,
      value: item.value,
      tooltip: item.tooltip,
      tooltipPosition: positions.TOP,
      id: props.id,
      isDisabled: isDisabled,
      onClick: onClick
    }, /*#__PURE__*/React.createElement(PrivateHeader, {
      font: props.font,
      text: item.text,
      byline: item.byline,
      icon: icon,
      image: image,
      isDisabled: isDisabled,
      size: props.size,
      assetDisplay: props.assetDisplay
    }));
  });
}

export var PrivateAssetRadioMenu = AssetRadioMenu;
export default compose(removeProps(['color']), whitelistStyles())(AssetRadioMenu);
//# sourceMappingURL=index.js.map